<template>
  <div class="content" :class="'content-'+theme">
    <div class="container-fluid">
      <transition name="fade" mode="out-in">
        <!-- your content here -->
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    theme() {
      return this.$auth.user().layout;
    }
  }
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s;
}

.fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

 {
  opacity: 0;
}
.content-black {
  background: #0b0c0d;
}
.content-light {
  background: #d8d8d8;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/Content.vue